import { ChangeEvent } from 'react';
import { FormCheck } from 'react-bootstrap';
import { CellProps } from 'react-table';
import LabelRequired from '../LabelRequired';
import { TableCustomCell } from '../table/components/TableCustomCell';
import { TableCustomHeader } from '../table/components/TableCustomHeader';
import { TableCustom } from '../table/table-custom/TableCustom';

type SurveyItem = {
	label: string;
	value: string;
};

type SurveyData = SurveyItem & { field: string };

type Props = {
	label?: string;
	values: SurveyItem[];
	data: SurveyData[];
	disabled?: boolean;
	onChange: (field: string, value: string) => void;
};

const Survey = ({ label, values, data, onChange, disabled }: Props) => {
	const columns = [
		{
			Header: (props: any) => (
				<TableCustomHeader
					tableProps={props}
					title=""
					className="text-center min-w-300px"
				/>
			),
			id: 'field',
			Cell: ({ row: { original } }: CellProps<any>) => (
				<TableCustomCell data={original.label} />
			),
		},
		...values.map((value) => ({
			Header: (props: any) => (
				<TableCustomHeader
					tableProps={props}
					title={value.label}
					className="text-center spaces min-w-40px"
				/>
			),
			id: value.value,
			Cell: ({ row: { original } }: CellProps<any>) => {
				return (
					<TableCustomCell
						data={
							<FormCheck
								type="radio"
								name={original.field}
								value={value.value}
								checked={original.value === value.value}
								aria-label={value.label}
								onChange={(e: ChangeEvent<HTMLInputElement>) => {
									onChange(original.field, e.target.value);
								}}
								disabled={disabled}
							/>
						}
						className="text-center"
					/>
				);
			},
		})),
	];

	return (
		<div>
			{label && <LabelRequired label={label} />}
			<TableCustom<any> className="overflow-auto spaces mt-4" data={data} columns={columns} />
		</div>
	);
};

export default Survey;
